export default "__VITE_ASSET__ev02yYri__"